/** MAPEO_OWNERS ⇄ texto editable ("Luis/Maflo = Maflo", una por línea). */
export function mapeoToText(mapeo: Record<string, string>): string {
  return Object.entries(mapeo).map(([k, v]) => `${k} = ${v}`).join('\n');
}

export function mapeoFromText(text: string): Record<string, string> {
  const out: Record<string, string> = {};
  for (const line of text.split('\n')) {
    const m = /^([^=]+)=([^=]+)$/.exec(line.trim());
    if (!m) continue;
    const key = m[1].trim().replace(/\s*\/\s*/g, '/');
    const val = m[2].trim();
    if (key && val) out[key] = val;
  }
  return out;
}

/** SENIORITY_NIVELES ⇄ texto editable ("Sr Analyst = Sr Analyst, Senior, Semi Senior", una por línea). */
export function nivelesToText(niveles: Record<string, string[]>): string {
  return Object.entries(niveles).map(([k, v]) => `${k} = ${v.join(', ')}`).join('\n');
}

export function nivelesFromText(text: string): Record<string, string[]> {
  const out: Record<string, string[]> = {};
  for (const line of text.split('\n')) {
    const m = /^([^=]+)=(.+)$/.exec(line.trim());
    if (!m) continue;
    const key = m[1].trim();
    const vals = [...new Set(m[2].split(',').map((v) => v.trim()).filter(Boolean))];
    if (key && vals.length) out[key] = vals;
  }
  return out;
}

/** Líneas no vacías que no respetan "clave = valor". */
export function lineasInvalidas(text: string): string[] {
  return text.split('\n').map((l) => l.trim()).filter(Boolean).filter((l) => !/^[^=]+=[^=]+$/.test(l));
}
